import { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import FJImage from '../../../../../common/components/FJImage/FJImage.jsx';
import styles from './FJImageList.module.less';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';
import PropTypes from 'prop-types';

const FJImageList = props => {
    const { list } = props;
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [previewSize, setPreviewSize] = useState({ width: 240, height: 240 });
    const [previewPosition, setPreviewPosition] = useState({ left: 0, top: 0 });
    const [isPreviewReady, setIsPreviewReady] = useState(false);
    const firstItemRef = useRef(null);
    const hoverTimerRef = useRef(null);

    // 计算预览框尺寸（返回Promise）
    const calculatePreviewSize = imgSrc => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                const { naturalWidth, naturalHeight } = img;
                const aspectRatio = naturalWidth / naturalHeight;

                let previewWidth = 240;
                let previewHeight = 240 / aspectRatio;

                // 如果高度超过240px，重新计算宽度
                if (previewHeight > 240) {
                    previewHeight = 240;
                    previewWidth = 240 * aspectRatio;
                }

                const size = {
                    width: Math.round(previewWidth),
                    height: Math.round(previewHeight),
                };
                resolve(size);
            };
            img.onerror = reject;
            img.src = imgSrc;
        });
    };

    // 组件卸载时清除定时器
    useEffect(() => {
        return () => {
            if (hoverTimerRef.current) {
                clearTimeout(hoverTimerRef.current);
            }
        };
    }, []);

    const handleMouseEnter = (index, imgSrc) => {
        // 清除之前的定时器
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
        }

        // 设置300ms延迟
        hoverTimerRef.current = setTimeout(async () => {
            try {
                // 先计算图片尺寸
                const size = await calculatePreviewSize(imgSrc);
                setPreviewSize(size);

                // 计算预览框位置（基于第一个图片元素）
                if (firstItemRef.current) {
                    const rect = firstItemRef.current.getBoundingClientRect();
                    setPreviewPosition({
                        left: rect.left,
                        top: rect.top,
                    });
                }

                // 尺寸和位置都准备好后，显示预览框
                setIsPreviewReady(true);
                setHoveredIndex(index);
            } catch (error) {
                console.error('Failed to load preview image:', error);
            }
        }, 100);
    };

    const handleMouseLeave = () => {
        // 清除定时器，如果还没触发就取消预览
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
        setHoveredIndex(null);
        setIsPreviewReady(false);
    };

    return (
        <>
            {hoveredIndex !== null &&
                isPreviewReady &&
                ReactDOM.createPortal(
                    <div
                        className={styles.preview_overlay}
                        style={{
                            width: `${previewSize.width + 20}px`,
                            height: `${previewSize.height + 20}px`,
                            left: `${previewPosition.left}px`,
                            top: `${previewPosition.top}px`,
                        }}
                    >
                        <FJImage
                            imgSrc={list[hoveredIndex]}
                            boxClassName={styles.preview_img_box}
                            imgClassName={styles.preview_img}
                            isShowLoading={true}
                        />
                    </div>,
                    document.body,
                )}
            <div className={styles.box}>
                {list.map((imgSrc, index) => {
                    return (
                        <div
                            ref={index === 0 ? firstItemRef : null}
                            className={styles.item_box}
                            key={index}
                            onMouseEnter={() => handleMouseEnter(index, imgSrc)}
                            onMouseLeave={handleMouseLeave}
                        >
                            <FJHoverBoardGradation active={hoveredIndex === index} isShowInBorder={true}>
                                <FJImage
                                    imgSrc={imgSrc}
                                    boxClassName={styles.images_img_box}
                                    imgClassName={styles.images_img}
                                    isShowLoading={true}
                                />
                            </FJHoverBoardGradation>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

FJImageList.propTypes = {
    list: PropTypes.array,
};

export default FJImageList;
